import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router/dom'
import { Providers } from './app/providers'
import { router } from './app/router'
import './styles/index.css'

const container = document.getElementById('root')
if (!container) {
  throw new Error('Root element #root is missing from index.html')
}

/**
 * Registered on load, not on opt-in.
 *
 * <p>A push subscription belongs to a service-worker registration, so the worker has to exist
 * before anybody can subscribe — and a browser that already holds a subscription from a
 * previous visit needs the worker back to deliver into it. Registering here rather than
 * inside the opt-in button is what makes a notification arrive when the app is merely open
 * rather than only after somebody has visited their profile.
 *
 * <p>The worker registers no fetch handler, so it caches nothing and cannot serve a stale
 * page. Failure is logged and ignored: an unsupported browser, an insecure origin, or a user
 * who has disabled service workers must all still get a working application.
 */
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((error: unknown) => {
      console.info('Push notifications are unavailable in this browser:', error)
    })
  })
}

createRoot(container).render(
  <StrictMode>
    <Providers>
      <RouterProvider router={router} />
    </Providers>
  </StrictMode>,
)
